// ══════════════════════════════════════════════════════════════════════════════════════════════
//  QUE ES UNA ARROBA DE APERTURA — EL MISMO CRITERIO QUE APLICA EL SERVIDOR
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  POR QUE EXISTE ESTE FICHERO, contado por el daño.
//
//  El criterio estaba escrito TRES veces con tres reglas distintas: el servidor
//  (backend/services/menciones.js) admitía cualquier carácter que no continuara una palabra; la
//  caja de escribir exigía principio de línea, un espacio o un paréntesis; y el diálogo de «vas a
//  avisar a N personas» exigía lo mismo que la caja. La más estricta de las tres era justamente la
//  ÚNICA salvaguarda que tiene @todos.
//
//  MEDIDO POR HTTP el 5-sep-2026: con «Recordatorio:@todos mañana cerramos» el servidor mencionaba
//  a las TRES personas del canal —les salía el push y la línea de la campana— y el diálogo no se
//  abría. Igual con «hola,@todos» y con «"@todos"». Y el desplegable tampoco salía, así que quien
//  escribía no veía ni la lista, ni el número, ni la pregunta: se enteraba después.
//
//  Ahora el criterio vive en shared/menciones-arroba.json y lo leen los dos lados. Un solo sitio.
import CRITERIO from '../../../shared/menciones-arroba.json' with { type: 'json' }

export const ALIAS_TODOS = CRITERIO.alias_todos
const SIGUE = new RegExp(CRITERIO.sigue_palabra, 'u')
const CIERRA = new RegExp(CRITERIO.cierra_palabra, 'u')
const NOMBRE = new RegExp(CRITERIO.nombre_tecleado, 'u')
const MAX_TECLEADO = Number(CRITERIO.max_tecleado) || 24

/** ¿La arroba ARRANCA una mención, viendo el carácter que tiene delante? */
export const abreMencion = (ch) => ch === undefined || !SIGUE.test(ch)
/** ¿Se acaba ahí el nombre? Detrás no puede seguir letra ni número («@Anabel» no es «@Ana»). */
export const cierraMencion = (ch) => ch === undefined || !CIERRA.test(ch)

/**
 * Lo que se está tecleando detrás de una arroba en la posición del cursor, o null.
 *   { inicio, q }   inicio = índice de la propia arroba · q = lo escrito detrás
 * Se lee hacia atrás desde el cursor mientras haya caracteres que puedan formar parte de un
 * nombre; el carácter anterior a la arroba decide si esa arroba abre algo (mismo criterio que el
 * servidor: por eso «ana@clinica.invalid» no despliega nada y «Recordatorio:@to» sí).
 */
export function detectarMencion(texto, caret) {
  const t = String(texto == null ? '' : texto)
  const fin = Math.max(0, Math.min(Number(caret) || 0, t.length))
  const antes = t.slice(0, fin)
  let i = antes.length
  while (i > 0 && NOMBRE.test(antes[i - 1]) && (antes.length - i) < MAX_TECLEADO) i--
  if (antes[i - 1] !== '@') return null
  if (!abreMencion(antes[i - 2])) return null
  return { inicio: i - 1, q: antes.slice(i) }
}

/**
 * ¿Este texto avisa a TODO el grupo? Es la pregunta de la que depende el único diálogo que frena
 * un @todos, así que se contesta con el MISMO barrido que hace el servidor sobre el texto que
 * guarda: no con una expresión regular parecida escrita al lado.
 */
export function mencionaATodos(texto) {
  const t = String(texto == null ? '' : texto).toLowerCase()
  for (let i = 0; i < t.length; i++) {
    if (t[i] !== '@' || !abreMencion(t[i - 1])) continue
    if (t.startsWith(ALIAS_TODOS, i + 1) && cierraMencion(t[i + 1 + ALIAS_TODOS.length])) return true
  }
  return false
}
